import { gql } from '@urql/core';

import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';

export const enableSiteMutation = ({ client, queryClient }) => ({
  mutationFn: ({ siteId, enable }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation SiteEnableAnalytics($siteId: Int!, $enable: Boolean!) {
          siteEnableAnalytics(siteId: $siteId, enable: $enable) {
            id
            webAnalyticsEnabled
          }
        }
      `,
      {
        siteId,
        enable,
      },
    ),
  onSuccess: () => {
    return queryClient.invalidateQueries({ queryKey: ['sites'] });
  },
});
